import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const PRESETS = [["padrao", "Padrão do plano", []], ["com", "Com adultos", ["1", "3", "5"]], ["sem", "Sem adultos", ["2", "4", "5"]]];
const same = (a, b) => a.length === b.length && a.every((x) => b.includes(x));

export const BouquetPicker = ({ value, onChange, prefix }) => {
  const [list, setList] = useState([]);
  const [custom, setCustom] = useState(false);
  useEffect(() => { if (custom && !list.length) api.get("/bouquets").then((r) => setList(r.data)); }, [custom, list.length]);
  const preset = PRESETS.find(([, , ids]) => same(ids, value))?.[0];
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div data-testid={`${prefix}-bouquets`}>
      <div className="mb-1 flex items-center justify-between text-xs text-slate-400">
        <span>Bouquets</span>
        <button type="button" data-testid={`${prefix}-bouquets-custom`} onClick={() => setCustom((x) => !x)} className="text-sky-400 hover:underline">
          {custom ? "fechar" : "personalizar"}
        </button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {PRESETS.map(([k, label, ids]) => (
          <button type="button" key={k} data-testid={`${prefix}-bouquets-${k}`} onClick={() => onChange(ids)}
            className={`rounded-lg border px-2 py-1.5 text-xs font-semibold transition-colors ${preset === k ? "border-sky-500 bg-sky-500/10 text-sky-200" : "border-[#1F293D] bg-[#111827] text-slate-300 hover:border-[#334155]"}`}>
            {label}
          </button>
        ))}
      </div>
      {custom && (
        <div className="mt-2 space-y-1">
          {list.map((b) => (
            <label key={b.id} data-testid={`${prefix}-bouquet-${b.id}`} className="flex cursor-pointer items-center gap-2 text-xs text-slate-300">
              <input type="checkbox" checked={value.includes(b.id)} onChange={() => toggle(b.id)} className="h-3.5 w-3.5 accent-sky-500" />
              <span className="font-mono text-slate-500">[{b.id}]</span> {b.name}
            </label>
          ))}
        </div>
      )}
      {!preset && <div data-testid={`${prefix}-bouquets-summary`} className="mt-1 text-[11px] text-amber-300">Personalizado: {[...value].sort().join(", ")}</div>}
    </div>
  );
};
